// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"50c4c92a","152":"ec7aeb62","237":"5f67c0af","246":"9dde68f7","364":"4c83498d","385":"4847290c","489":"722d799c","538":"996fbcf7","587":"022ec1fb","610":"5ee51fbf","690":"373bf76f","781":"5dde4845","888":"687e7f3c","908":"4c6f4996","963":"2d9e9200","988":"3471e1c7"}[chunkId] + ".chunk.js";
};